export default "__VITE_ASSET__DBNMZJb___"